import {styled} from "@mui/material/styles"
import {Box} from "@mui/material"

export const Wrapper = styled("div")`
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    width: 2.75rem;
    height: 2.75rem;

    picture {
        display: flex;
    }

    img {
        display: block;
    }
`

export const StyledBox = styled(Box)`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
`

export const StyledA = styled("a")`
    align-items: inherit;
    justify-content: inherit;
    width: inherit;
    height: inherit;
    display: inherit;
`
